import { resource, RequestConfig } from '../helper/resource';

/**
 * 获取客户待签署合同列表
 */
export function trustServer_signedListUsingPOST(
  req: TrustServer.LcProfitProofParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultListLcSypzClientContract> {
  return resource.post('/lc/LcProfitProof/client/signedList', req, config);
}

/**
 * 个人/机构客户签署合同
 */
export function trustServer_signUsingPOST(
  req: TrustServer.CreateSignParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultboolean> {
  return resource.post('/lc/LcProfitProof/contract/sign', req, config);
}

/**
 * 获取收益凭证详情
 */
export function trustServer_queryDetailInfoUsingPOST(
  req: TrustServer.LcProfitProofParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultLcProfitProofDetailDto> {
  return resource.post('/lc/LcProfitProof/queryDetailInfo', req, config);
}

/**
 * 获取挂钩标的行情
 */
export function trustServer_queryRelateStockUsingPOST(
  req: TrustServer.LcQtIndexHisReqParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultListLcQtIndexHisDto> {
  return resource.post('/lc/LcProfitProof/queryRelateStock', req, config);
}

/**
 * [No Auth]获取费用信息-(机构理财)
 */
export function trustServer_getFeesUsingPOST(
  req: TrustServer.FeeDetailDto | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultListFeeDetailVo> {
  return resource.postNoAuth('/lc/getFees', req, config);
}

/**
 * [No Auth]获取网址信息-(机构理财)
 */
export function trustServer_getWebSiteUsingPOST(
  req: TrustServer.FeeDetailDto | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultWebSiteVo> {
  return resource.postNoAuth('/lc/getWebSite', req, config);
}

/**
 * 查询未回访记录
 */
export function trustServer_queryUsingPOST(
  req: void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultListPurchaseRecord> {
  return resource.post('/lc/revisit/query', req, config);
}

/**
 * 查询回访详情
 */
export function trustServer_queryDetailsUsingPOST(
  req: TrustServer.LcFundAssetReturnDto | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultListRevisitVo> {
  return resource.post('/lc/revisit/queryDetails', req, config);
}

/**
 * 回访
 */
export function trustServer_revisitUsingPOST(
  req: TrustServer.LcFundAssetReturn | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultboolean> {
  return resource.post('/lc/revisit/revisit', req, config);
}

/**
 * [No Auth]根据产品代码查询产品文件路径
 */
export function trustServer_searchFindFileUsingPOST(
  req: TrustServer.SearchFindFileParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultListLcFundFilePathVo> {
  return resource.postNoAuth('/lc/searchFindFile', req, config);
}
